import {WarningOctagon} from '@phosphor-icons/react';
import {Loading} from 'Components/Loading';
import {Typography} from 'Components/Typography';
import {useUserContext} from 'Contexts/UserContext/UserContext';
import React from 'react';
import useSWR from 'swr';
import {DefaultCSS} from './DefaultCSS';
import {TailwindConfig} from './TailwindConfig';

interface Props {}

export const CodeConfig = (props: Props) => {
    const user = useUserContext();
    const {data, isLoading, error} = useSWR('code-config' + user.userId, user.getUserDefaultProject);

    if (error) {
        return (
            <div className="flex items-center text-red-500 px-8 py-2">
                <WarningOctagon weight="fill" size={24} className="mr-2" />
                <span>{error}</span>
            </div>
        );
    }

    if (isLoading) {
        return <Loading />;
    }

    const project = data.data;

    return (
        <div className="flex h-full w-full flex-col md:flex-row gap-12 items-start justify-center bg-gray-50 px-4 sm:p-6 lg:p-8">
            <div className="flex flex-col gap-4">
                <Typography.H1>Tailwind Config</Typography.H1>
                <TailwindConfig project={project} />
            </div>
            <div className="flex flex-col gap-4">
                <Typography.H1>CSS Config</Typography.H1>
                <DefaultCSS project={project} />
            </div>
        </div>
    );
};
